import { DatePickerProps } from 'antd/lib/date-picker';
import React from 'react';
import styled from 'styled-components';
import {
  DatePicker as AntdDatePicker,
  Picker,
} from 'components/atoms/date-picker';
import { getBackgroundColor } from 'components/atoms/input/input';
import { useAntdRlUISwitcher } from 'contexts/antd-rlui-switcher';

// Rocketlane UI styled component with new design
export const RocketlaneUIDatePicker = styled(Picker)<DatePickerProps>`
  background-color: ${getBackgroundColor(true)};
  padding: 0 var(--spacing-05);
  height: var(--input-size-sm);
  &.ant-picker-disabled {
    opacity: 0.5;
  }
`;

const DatePickerComponent = React.forwardRef<any, DatePickerProps>(
  (props, ref) => {
    const isNewDesignEnabled = useAntdRlUISwitcher();

    if (isNewDesignEnabled) {
      const { className, ...restProps } = props;

      return (
        <RocketlaneUIDatePicker
          {...restProps}
          ref={ref}
          className={`rl-date-field${className ? ` ${className}` : ''}`}
        />
      );
    }

    return <AntdDatePicker {...props} ref={ref} />;
  },
);

DatePickerComponent.displayName = 'DatePicker';

// Wrap in styled() so it can be used as ${DatePicker} in styled-component interpolations
export const DatePicker = styled(DatePickerComponent)<DatePickerProps>``;
DatePicker.displayName = 'DatePicker';
